/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import CampaignPromoBarModuleRenderer, {
  useShouldShowCampaignPromoBarModule,
} from 'bundles/campaigns/module-renderers/CampaignPromoBarModuleRenderer';
import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';

type Props = {
  pageData?: ConsumerCoursePageFieldsFragment | ConsumerSpecializationPageFieldsFragment;
};

const styles = {
  container: css`
    overflow: hidden;
    position: relative;
    z-index: 1;
  `,
};

const PageBannerModuleRenderer = (_props: Props) => {
  if (useShouldShowCampaignPromoBarModule()) {
    let bannerColourExperiment: string | undefined = GrowthDiscoveryExperiments.get('promoBarBannerColourExperiment');
    if (bannerColourExperiment === 'control') {
      bannerColourExperiment = undefined;
    }
    return (
      <div css={styles.container}>
        <CampaignPromoBarModuleRenderer bannerColourExperiment={bannerColourExperiment} />
      </div>
    );
  }

  return null;
};

export default PageBannerModuleRenderer;
